<div class="item"
     [class.pop-disabled]="disabled">
    <span [translate]="labelKey"></span>
    <pop-radio-button-group [options]="budgetTypes"
                            (click)="click($event)"
                            [(selectedOption)]="selectedType">
    </pop-radio-button-group>
</div>
